import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import renderIf from 'render-if';
import PropTypes from 'prop-types';
import Filter from './components/Filter';
import styles from './style.scss';// to import local scss fle
import Tiles from './components/Tiles';


class DivisionBasedStudents extends React.Component {
  static propTypes = {
    divisionBasedStudents: PropTypes.func.isRequired,
    getDivisionStudents: PropTypes.func.isRequired,
    getFilteredDivisionStudents: PropTypes.func.isRequired,
  };
  state = {
  };

  render() {
    const { divisionBasedStudents, getDivisionStudents, getFilteredDivisionStudents } = this.props;
    const renderTiles = renderIf(divisionBasedStudents.size > 0);
    const renderNoContentFind = renderIf(divisionBasedStudents.size === 0);
    return (
      <div className={cn('col s12', styles.mainContainer)}>
        <Filter
          getDivisionStudents={getDivisionStudents}
          getFilteredDivisionStudents={getFilteredDivisionStudents}
        />
        <div className={cn('col s12', styles.container)}>
          {renderTiles(
            <div>
              {divisionBasedStudents.map(item => (
                <Tiles item={item} />
        ))}
            </div>,
        )}
          {renderNoContentFind(
            <div className={cn('col s12', styles.adaptContainer)}>
              <div className={styles.emptyImage}>
                <img src="https://media.dev.myrecruitboard.com/Images/no-reco-found%403x.png" alt="empty screen" />
              </div>
              <div className={styles.noDescFound}>
              No recommendations found.
            </div>
            </div>,
        )}
        </div>
      </div>
    );
  }
}

export default DivisionBasedStudents;



// WEBPACK FOOTER //
// ./src/components/CoachDashboardView/components/DivisionBasedStudent/View.js